import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { AUTOMATION_STEP_MUTATION_SCOPE, AUTOMATION_TEMPLATE_MUTATION_KEY } from '../Automation/queryKeys';

interface Params {
	templateId: string;
	stepId: string;
	attachmentId: string;
	impersonationContext?: Api.IImpersonationContext;
}

export function useAutomationTemplateStepHtmlNewsletterAttachmentDeleteMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.IHtmlNewsletterAutomationStep, variables: Params) => void;
	onError?: (error: Api.IOperationResultNoValue, variables: Params) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationKey: AUTOMATION_TEMPLATE_MUTATION_KEY,
		scope: AUTOMATION_STEP_MUTATION_SCOPE,
		mutationFn: ({ templateId, stepId, attachmentId, impersonationContext }: Params) => {
			return userSession.webServiceHelper.callAsync<Api.IHtmlNewsletterAutomationStep>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(templateId)}/Step/HtmlNewsletter/${encodeURIComponent(stepId)}/Attachment/${encodeURIComponent(attachmentId)}`,
					impersonationContext,
				}),
				'DELETE',
				null
			);
		},
		onError,
		onSuccess,
	});
}
